import { Component } from '@angular/core';

@Component({
    selector: 'feather-character',
    templateUrl: '../../../../../../src/assets/svgs/characters/feather.svg',
    styleUrls: ['../svg.component.scss']
})
export class FeatherCharacter {

}